<p-toast
  position="top-right"
  key="expire"
  styleClass="custom-p-toast"
  [baseZIndex]="5000"
>
  <ng-template let-message pTemplate="message">
    <div class="flex flex-row">
      <img src="../../assets/images/exclaimation.svg" alt="exclaimation.svg" />
      <div class="flex flex-column align-items-start ml-3" style="flex: 1">
        <div class="flex align-items-center gap-2">
          <span class="font-bold text-700">Alert</span>
        </div>
        <div class="font-medium text-lg my-1 text-700">
          {{ message.summary }}.
          <p class="link-attr" (click)="navigate()">
            Click here to change
          </p>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
